import Home from "./pages/Home";
import SignIn from "./pages/SignIn";
import Login from "./pages/Login";
import CreateWorkout from "./pages/CreateWorkout";
import CustomerDetails from "./pages/CustomerDetails";
import Instructors from "./pages/Instructors";
import NewEvaluation from "./pages/NewEvaluation";
import ProfilePage from "./pages/ProfilePage";
import BillingSettings from "./pages/BillingSettings";
import WorkoutsLibrary from "./pages/WorkoutsLibrary";
import CustomerImports from "./pages/CustomerImports";
import ChallengeManager from "./pages/ChallengeManager";
import Products from "./pages/Products";
import Groups from "./pages/Groups";
import Communities from "./pages/Communities";

import { useNavigate } from "react-router-dom";

import "./App.css";
import "./assets/spacing.css";

import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

import React, { useState, useEffect } from "react";
import { Routes, BrowserRouter, Route } from "react-router-dom";

import Confirm from "./components/SmallComponents/Confirm";
import UserModal from "./components/Modals/UserModal";

import { AuthProvider, useAuth } from "./contexts/AuthContext.js";
import {
  ChallengeProvider,
  useChallenge,
} from "./contexts/ChallengeContext.js";

import { ThemeProvider } from "@mui/material/styles";

import Config, { token } from "./config.js";

import { ReactComponent as WhiteLogoSVG } from "./assets/logo/M_WHITE_LOGO_FULL.svg";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import theme from "./assets/theme.js";

const stripePromise = loadStripe(Config.payments.stripeKey);

const routes = {
  public: {
    "": Login,
    signin: SignIn,
  },
  private: {
    "": Home,
    imports: CustomerImports,
    challenges: ChallengeManager,
    groups: Groups,
    communities: Communities,
    products: Products,
  },
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <AuthProvider>
          <Elements stripe={stripePromise}>
            <ChallengeProvider>
              <ProtectedRoutes />
            </ChallengeProvider>
          </Elements>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  );
}

const ProtectedRoutes = () => {
  const { signed, loading } = useAuth();

  const [configured, setConfigured] = useState(false);

  const { loading: challengeLoading } = useChallenge();

  useEffect(() => {
    if (!challengeLoading) {
      setTimeout(() => {
        setConfigured(true);
      }, 1500);
    }
  }, [challengeLoading]);

  if ((!signed && loading) || (signed && challengeLoading))
    return <LoadingComponent />;

  const mode = !!signed ? "private" : "public";

  const currentRoutes = routes[mode];

  return (
    <Routes>
      {Object.keys(currentRoutes).map((path, i) => {
        const Component = currentRoutes[path];
        return (
          <Route
            path={"/" + path}
            key={i}
            element={
              <>
                <Confirm />
                <UserModal />
                <Component />
              </>
            }
          />
        );
      })}
    </Routes>
  );
};

export default App;

const LoadingComponent = ({}) => {
  return (
    <div className="loading-screen">
      <WhiteLogoSVG />
    </div>
  );
};
